import React from "react";
import { Modal } from "react-responsive-modal";
import {
  TitleProduct,
  SubTitleProduct,
} from "../../components/modal/style/ConfirmationModalStyle";

import { Flex } from "../../styles/GlobalStyle";
import { withTranslation } from "react-i18next";

const customStyles = {
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    zIndex: "20",
    outline: "none",
    border: "none",
    width: "30px",
  },
  modal: "relative p-0 rounded-2xl h-72 w-96",
  overlay: {
    padding: "0",
  },
};

const SimpleModal = ({
  showConfirmation,
  openCloseModal,
  showCloseIcon,
  content,
  modalTitle,
}) => {
  return (
    <Modal
      classNames={customStyles}
      open={showConfirmation}
      onClose={() => {
        openCloseModal(!showConfirmation);
        const html = document.querySelector("html");
        html.style = "";
      }}
      showCloseIcon={showCloseIcon}
      center>
      <Flex>
        <ModalContent
          onCancel={() => openCloseModal(!showConfirmation)}
          children={content}
          modalTitle={modalTitle}
        />
      </Flex>
    </Modal>
  );
};

export default withTranslation()(SimpleModal);

function ModalContent({ children, modalTitle }) {
  return (
    <Flex
      flex={1}
      height={"100%"}
      alignItems={"center"}
      justifyContent={"center"}>
      <Flex height="56px">
        {modalTitle && (
          <>
            <TitleProduct className={"modalTitle"}>{modalTitle}</TitleProduct>
            <hr />
          </>
        )}
      </Flex>
      <Flex
        flex={1}
        height={"100%"}
        alignItems={"center"}
        justifyContent={"center"}>
        <SubTitleProduct className={"modalSubtitle"}>
          {children}
        </SubTitleProduct>
      </Flex>
    </Flex>
  );
}
